module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/async/loaders/syncloader.js!./loaders/async/loaders/syncloader.js!./loaders/async/a.js
 ** module id = 2
 ** module chunks = 0
 **/